package com.eladfinish.bible.contest.appcontent

/** The developer bio and credits shown on the app's About screen and on the website's about page. */
object AboutContent {
    const val DEVELOPER_NAME = "אלעד פיניש"

    val achievements: List<String> = listOf(
        """חתן התנ"ך הארצי וסגן חתן התנ"ך העולמי בחידוני התנ"ך לנוער לשנת תשס"ח - 2008.""",
        """חתן חידון התנ"ך למבוגרים במחוז דרום לשנת תשע"ח - 2017.""",
        """סגן שלישי בחידון התנ"ך הארצי למבוגרים לשנת תשפ"א - 2020.""",
        """סגן ראשון בחידון התנ"ך הארצי למבוגרים לשנת תשפ"ג - 2022.""",
    )

    val thanks: List<String> = listOf(
        "תודה לכל המשתמשים מכל העולם שדירגו את האפליקציה, העירו הערות ושלחו לי הצעות לשיפור.",
        """תודה לישראל אלגרבלי, סגן חתן התנ"ך העולמי לשנת תשע"ה - 2015, על עזרתו בכתיבת השאלות האמריקאיות.""",
        """תודה לרגב גולן, חתן התנ"ך במחוז ת"א לשנת תשע"ו - 2016, על עזרתו בכתיבת השאלות הפתוחות.""",
        """תודה לפתחיה מיוחס, על עזרתו בליקוט הסדרים בתנ"ך.""",
        "תודה לאור אגו, תוכניתן וגרפיקאי מוכשר, על עזרתו ביצירת אייקון לאפליקציה.",
    )

    const val FEEDBACK_PROMPT = "מצאתם באג? רעיון לשיפור? ספרו לי!"
}
